import { camelCase, kebabCase, pascalCase } from 'change-case';

export const cssToModule = (styleDef: string) => camelCase(styleDef);
export const moduleToCss = (styleDef: string) => kebabCase(styleDef);
export const nameToClass = (name: string, suffix = '') =>
  pascalCase(`${name} ${suffix}`.trim());
